// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// mobx
import { action } from 'mobx';

// data
import { IndustrySource } from '../sources';

export class IndustryStore extends Store {
  private industrySource: IndustrySource;

  public constructor(industrySource: IndustrySource, state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
    this.industrySource = industrySource;
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this.industrySource, data.industrySource);
  }

  @action
  public getIndustries() {
    return this.industrySource.getIndustries();
  }
}
